import React from "react";
import AdminFeatureTour, {
  markTourSeen,
  shouldAutoStartTour,
} from "../../components/AdminFeatureTour";

export const THEMEUPDATE_TOUR_STORAGE_KEY = "sl_admin_themeupdate_tour_seen_v1";

export const THEMEUPDATE_TOUR_STEPS = [
  {
    id: "welcome",
    target: "tour-gc-header",
    title: "Game Content",
    body: "This page is where you add quiz questions, the Down and Across crossword, audio questions, and image match pairs for the theme.",
  },
  {
    id: "tabs",
    target: "tour-gc-tabs",
    title: "Game tabs",
    body: "Switch between the Quiz, Down and Across, Audio, and Match Pair editors here.",
  },
  {
    id: "questions",
    target: "tour-gc-quiz",
    tab: "quiz",
    title: "Add Questions",
    body: "Add, edit, delete, or CSV-import questions. Questions are saved on the theme (quiz), not in a questions table.",
  },
  {
    id: "down-across",
    target: "tour-gc-down-across",
    tab: "downAndAcross",
    title: "Down and Across",
    body: "Add 2–8 question/answer pairs. The crossword grid is generated automatically — check the preview, then click Save and Continue.",
  },
  {
    id: "audio",
    target: "tour-gc-audio",
    tab: "audio",
    title: "Audio questions",
    body: "Upload an audio clip for each question (MP3, M4A, WAV or OGG, max 20 MB), add 2–4 options, and pick the correct answer. CSV import/export is supported too.",
  },
  {
    id: "match-pair",
    target: "tour-gc-match-pair",
    tab: "matchPair",
    title: "Match pairs",
    body: "Add 3–6 pairs of an image and its answer text. Players match each image to the right name. Click Save and Continue to upload the images and save.",
  },
];

export default function ThemeUpdateFeatureTour({ open, onClose, onStepChange }) {
  return (
    <AdminFeatureTour
      open={open}
      onClose={onClose}
      steps={THEMEUPDATE_TOUR_STEPS}
      onStepChange={onStepChange}
    />
  );
}

export function markThemeUpdateTourSeen() {
  markTourSeen(THEMEUPDATE_TOUR_STORAGE_KEY);
}

export function shouldAutoStartThemeUpdateTour() {
  return shouldAutoStartTour(THEMEUPDATE_TOUR_STORAGE_KEY);
}
